/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React, { useMemo } from 'react';
import { Avatar, useTheme } from '@mui/material';
import { Tokens } from '@jda/lui-common-component-library-mui5';
import { IAvatar } from '../../models/Common/GenerateAvatar';

export const GenerateAvatar = (item: IAvatar) => {
  const theme = useTheme();
  return useMemo(() => {
    const addAvatarColor = (priorityValue: number = 0) => {
      return Tokens.colors[`${theme.palette.mode}Theme`].priority[priorityValue];
    };
    return (
      <Avatar
        data-testid="avatar"
        key={item.id}
        alt={item.name}
        style={{ backgroundColor: addAvatarColor(item.priority) }}
      >
        {item.name.charAt(0).toUpperCase()}
      </Avatar>
    );
  }, [theme, item]);
};
